<template>
    <AuthPageInner title="Complete Registration">
        <template v-if="user.id">
            <template v-if="user.registration_completed_at">
                <div class="bg-orange-100 border-l-4 border-orange-500 text-orange-700 p-4 mb-8" role="alert">
                    <p class="font-bold">Warning</p>
                    <p>It looks like registration has already been completed for this account.</p>
                </div>

                <router-link :to="{name: 'login'}">
                    Continue to login
                </router-link>
            </template>

            <CompleteRegistrationForm v-else ref="form" :email="user.email" @success="onSuccess"/>
        </template>
    </AuthPageInner>
</template>

<script>

import axios from "axios";
import AuthPageInner from "@/Components/Layout/AuthPageInner";
import CompleteRegistrationForm from "@/Components/Auth/CompleteRegistrationForm";

export default {

    name: "CompleteRegistrationPage",

    data() {
        return {
            user: {}
        };
    },

    mounted() {
        this.$nextTick(() => {
            if (this.$refs.hasOwnProperty('form')) {
                this.$refs.form.focus();
            }
        })
    },

    components: {
        AuthPageInner,
        CompleteRegistrationForm
    },

    methods: {
        onSuccess() {
            this.$router.push('/');
        }
    },

    async beforeRouteEnter(to, from, next) {
        const user = (await axios.get(to.fullPath)).data;

        next(vm => vm.user = user);
    }
}
</script>
